import type { QueryClient } from '@tanstack/react-query';

import { formatUnknownError } from '@/lib/error-format';
import { queryKeys } from '@/lib/query-keys';

export function formatAgreementMutationError(error: unknown): string {
  return formatUnknownError(error);
}

export function invalidateAgreementTemplateQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: queryKeys.agreements.templates });
}

export function invalidateAgreementListQueries(queryClient: QueryClient) {
  queryClient.invalidateQueries({ queryKey: queryKeys.agreements.all });
}
